import { DownloadIcon } from "../../../../../../packages/icons";
import styles from "./file.module.scss";

type Props = {
  onClick: () => void;
};

const DownloadButton = ({ onClick }: Props) => (
  <div className={styles["download-button"]}>
    <a onClick={onClick}>
      <DownloadIcon />
    </a>
  </div>
);

export { DownloadButton };
